module.exports = __webpack_public_path__ + "static/story2-1e47121ec40d018b58e69915d6dfd529.png";